import React, { useState } from "react";

const InteractiveDemo = () => {
  const [activeTab, setActiveTab] = useState("preview");

  return (
    <section
      id="interactive-demo"
      className="py-16 sm:py-20 lg:py-24 bg-slate-50 border-y border-[#E2E8F0] overflow-hidden"
    >
      <div className="mx-auto w-[95%] md:w-[90%]">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16 animate-fade-in-up">
          <h2 className="text-sm sm:text-base font-bold tracking-[0.2em] text-[#E63946] uppercase mb-3 sm:mb-4">
            Experience the Speed
          </h2>
          <h3 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B1C2D] lg:text-5xl mb-4 sm:mb-6">
            Interactive Demo – See It In Action.
          </h3>
          <p className="text-base sm:text-lg text-[#64748B]">
            Test it. Copy it. Go live in minutes. Experience real-time
            submission notifications and see how easy it is to manage leads
            without any technical setup.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
          <div className="w-full lg:w-3/5 bg-white rounded-2xl sm:rounded-[2rem] shadow-2xl border border-[#E2E8F0] overflow-hidden opacity-0 animate-fade-in-up">
            <div className="bg-[#0B1C2D] px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
              <div className="flex gap-1.5 sm:gap-2 shrink-0">
                <div className="size-2.5 sm:size-3 rounded-full bg-[#E63946]"></div>
                <div className="size-2.5 sm:size-3 rounded-full bg-slate-600"></div>
                <div className="size-2.5 sm:size-3 rounded-full bg-slate-600"></div>
              </div>
              <div className="flex bg-white/10 rounded-lg p-1">
                <button
                  type="button"
                  onClick={() => setActiveTab("preview")}
                  className={`px-2.5 sm:px-4 py-1 text-[9px] sm:text-[10px] font-bold rounded-md transition-all whitespace-nowrap ${
                    activeTab === "preview"
                      ? "bg-white text-[#0B1C2D]"
                      : "text-white/60 hover:text-white"
                  }`}
                >
                  LIVE PREVIEW
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("code")}
                  className={`px-2.5 sm:px-4 py-1 text-[9px] sm:text-[10px] font-bold rounded-md transition-all whitespace-nowrap ${
                    activeTab === "code"
                      ? "bg-white text-[#0B1C2D]"
                      : "text-white/60 hover:text-white"
                  }`}
                >
                  GET CODE
                </button>
              </div>
            </div>

            <div className="p-4 sm:p-8 min-h-[360px] sm:min-h-[450px] flex items-center justify-center">
              {activeTab === "preview" ? (
                <div className="w-full max-w-md space-y-5 sm:space-y-6">
                  <div className="text-center mb-4 sm:mb-8">
                    <h4 className="text-lg sm:text-xl font-bold text-[#0B1C2D]">
                      Get in Touch
                    </h4>
                    <p className="text-sm text-[#64748B]">
                      This is a functional ContactHQ form
                    </p>
                  </div>
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] font-bold text-[#0B1C2D] uppercase">
                          Full Name
                        </label>
                        <input
                          type="text"
                          placeholder="Rahul Kumar"
                          className="w-full px-4 py-3 rounded-xl border border-[#E2E8F0] bg-slate-50 text-sm focus:border-[#E63946] outline-none"
                        />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] font-bold text-[#0B1C2D] uppercase">
                          Email
                        </label>
                        <input
                          type="email"
                          placeholder="rahul@dev.in"
                          className="w-full px-4 py-3 rounded-xl border border-[#E2E8F0] bg-slate-50 text-sm focus:border-[#E63946] outline-none"
                        />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <label className="text-[10px] font-bold text-[#0B1C2D] uppercase">
                        Inquiry Type
                      </label>
                      <select className="w-full px-4 py-3 rounded-xl border border-[#E2E8F0] bg-slate-50 text-sm outline-none">
                        <option>Web Design Project</option>
                        <option>SaaS Consultation</option>
                        <option>General Support</option>
                      </select>
                    </div>
                    <button
                      type="button"
                      className="w-full py-3.5 sm:py-4 rounded-xl bg-[#0B1C2D] text-white font-bold hover:bg-[#E63946] transition-all"
                    >
                      Send to Centralized Inbox
                    </button>
                  </div>
                </div>
              ) : (
                <div className="w-full font-mono text-xs sm:text-sm overflow-hidden">
                  <div className="bg-[#0f172a] rounded-2xl p-4 sm:p-6 text-blue-300 relative overflow-x-auto">
                    <button
                      type="button"
                      className="absolute top-3 right-3 bg-white/10 hover:bg-white/20 text-white text-[10px] py-1 px-3 rounded-md z-10"
                    >
                      COPY CODE
                    </button>
                    <div className="pr-16 min-w-[260px] space-y-0.5">
                      <p>
                        <span className="text-pink-400">{"<form "}</span>
                        {"action="}
                        <span className="text-green-400">
                          "https://contacthq.io/f/dev_123"
                        </span>
                        {">"}
                      </p>
                      <p className="pl-4">
                        {"<input "}
                        <span className="text-yellow-400">type</span>
                        {"="}
                        <span className="text-green-400">"text"</span>
                        {" name="}
                        <span className="text-green-400">"name"</span>
                        {" />"}
                      </p>
                      <p className="pl-4">
                        {"<input "}
                        <span className="text-yellow-400">type</span>
                        {"="}
                        <span className="text-green-400">"email"</span>
                        {" name="}
                        <span className="text-green-400">"email"</span>
                        {" />"}
                      </p>
                      <p className="text-pink-400">{"</form>"}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="w-full lg:w-2/5 space-y-8 sm:space-y-10">
            {[
              {
                title: "Try the Live Demo",
                desc: "Experience real-time submission notifications and see how easy it is to assign, tag, and reply to messages without leaving the dashboard.",
                icon: "ads_click",
              },
              {
                title: "Copy & Embed in Seconds",
                desc: "Works on WordPress, Shopify, Vercel, or plain HTML. Just copy the snippet or CDN link and your form is live instantly.",
                icon: "data_object",
              },
              {
                title: "Customizable & Dev-Friendly",
                desc: "Change colors, styles, or field types with simple parameters. Use webhooks to connect to Zapier, HubSpot, or Notion.",
                icon: "settings_input_component",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="flex gap-4 sm:gap-6 opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${400 + i * 150}ms` }}
              >
                <div className="flex-none flex items-center justify-center size-11 sm:size-12 rounded-2xl bg-white border border-[#E2E8F0] text-[#E63946] shadow-sm">
                  <span className="material-symbols-outlined">{item.icon}</span>
                </div>
                <div className="min-w-0">
                  <h4 className="text-base sm:text-lg font-bold text-[#0B1C2D] mb-1.5 sm:mb-2">
                    {item.title}
                  </h4>
                  <p className="text-[#64748B] text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}

            <div className="p-5 sm:p-6 rounded-2xl bg-[#0B1C2D] text-white space-y-4 opacity-0 animate-fade-in-up [animation-delay:1s]">
              <div className="flex items-center gap-3">
                <span className="material-symbols-outlined text-[#E63946]">
                  bolt
                </span>
                <p className="text-sm font-bold tracking-wide">
                  WHY IT WORKS SO WELL
                </p>
              </div>
              <ul className="space-y-2">
                {[
                  "Instant feedback in your centralized inbox.",
                  "No backend or server-side magic required.",
                  "Optimized for India and global users.",
                ].map((line) => (
                  <li
                    key={line}
                    className="flex items-start gap-2 text-xs text-slate-300"
                  >
                    <span className="material-symbols-outlined text-[14px] text-green-400 mt-0.5">
                      check_circle
                    </span>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InteractiveDemo;
